import { useState } from 'react';
import { setToken } from '../lib/api';

interface Props {
  onDone: () => void;
  message?: string;
}

/** One-time setup screen — appears when no token is stored or after the API returns 401.
 *  Doesn't validate the token here; we let the first real fetch surface the error so we don't
 *  duplicate the validation rules. */
export function TokenSetup({ onDone, message }: Props) {
  const [value, setValue] = useState('');
  return (
    <div className="min-h-full flex items-center justify-center p-6">
      <form
        className="w-full max-w-md rounded-lg border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-6 shadow-sm"
        onSubmit={(e) => {
          e.preventDefault();
          const v = value.trim();
          if (!v) return;
          setToken(v);
          onDone();
        }}
      >
        <h1 className="text-lg font-semibold mb-2">rag-a-muffin</h1>
        <p className="text-sm text-zinc-600 dark:text-zinc-400 mb-4">
          Paste a bearer token to access the code-RAG index. The token is stored in your browser's{' '}
          <code className="font-mono text-xs">localStorage.code_rag_token</code> and sent on every
          API request.
        </p>
        {message && (
          <p className="text-sm rounded bg-amber-50 dark:bg-amber-950 border border-amber-300 dark:border-amber-800 text-amber-900 dark:text-amber-100 p-2 mb-3">
            {message}
          </p>
        )}
        <label className="block text-sm font-medium mb-1" htmlFor="token-input">
          Bearer token
        </label>
        <input
          id="token-input"
          type="password"
          autoFocus
          autoComplete="off"
          className="w-full rounded border border-zinc-300 dark:border-zinc-700 bg-white dark:bg-zinc-950 px-2 py-1.5 text-sm font-mono"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <button
          type="submit"
          className="mt-4 w-full rounded bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium px-3 py-2"
        >
          Save & continue
        </button>
        <p className="mt-3 text-xs text-zinc-500 dark:text-zinc-400">
          Token validation happens on the first request. If the server rejects it, you'll see
          this screen again.
        </p>
      </form>
    </div>
  );
}
